import type { ReactNode } from 'react'

import { useAuth } from '@/hooks/useAuth'

import { CampLoader } from './CampLoader'

/** Holds the routes until `auth.me` answers, showing `pending` (the camp's loader by default) meanwhile. */
export function AuthGate({ children, pending }: { children: ReactNode; pending?: ReactNode }) {
  const { isLoading } = useAuth()

  if (isLoading) {
    return <>{pending ?? <CampLoader />}</>
  }

  return <>{children}</>
}
